import {atom} from "recoil";
import memoize from "lodash.memoize";

const mAtom = memoize(atom, ({key}) => key);

export default mAtom;
